import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { apiRequest } from '../../utils';
import { Storefront } from '../storefront';

/* tornea.app/<slug> is either a business unit's brand storefront or an event's short link
   (Machina ▸ Content ▸ Website). The event link wins the lookup only because the two never
   share a word — both setters refuse the other's.

   A short link becomes the `otherEventId` the old ?otherEventId=<guid> links set: /branding
   then dresses the login screen in the event's share picture, logo and colour, and /login
   lands the person in that event. Anything else renders the storefront exactly as before. */
const SlugEntry = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState('checking');

  useEffect(() => {
    let cancelled = false;
    setState('checking');
    apiRequest('GET', `/event-link/${encodeURIComponent(slug)}`)
      .then((res) => {
        if (cancelled) return;
        sessionStorage.setItem('otherEventId', res.event_id);
        // A brand visited earlier in this tab must not scope the login to another business.
        sessionStorage.removeItem('brandLoginSlug');
        navigate('/login', { replace: true });
      })
      .catch(() => { if (!cancelled) setState('storefront'); });
    return () => { cancelled = true; };
  }, [slug, navigate]);

  // One small lookup — a blank beat rather than a storefront that flashes "not found".
  return state === 'storefront' ? <Storefront /> : null;
};

export default SlugEntry;
